<template>
  <div>
    <nav class="nav navbar fixed-top bg-white px-2">
      <div class="nav-item">
        <button @click.prevent="$router.back()" class="btn btn-outline">
          <i class="fas fa-chevron-left"></i></button>
      </div>
      <div class="navbar-brand text-truncate flex-fill mb-0"><b>{{ channel.display_name || '' }}</b></div>
      <div v-if="channel.channel_type === 'P'" class="nav-item flex-shrink-0">
        <button @click.prevent="leaveChannel" class="btn btn-outline-secondary btn-sm">
          <i class="fas fa-sign-out-alt"></i>
        </button>
      </div>
    </nav>
    <div v-if="channelId" class="container-fluid mt-2 py-5">
      <channel :channelId="channelId"></channel>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Channel from '@/components/channel/channel.vue'

export default {
  name: 'ChannelView',
  components: {
    Channel,
  },
  props: {
      channelName: {type: String, required: true},
  },
  data() {
    return {
      channelId: '',
      channel: {},
    }
  },
  computed: {
  },
  created() {
    if (navigator.onLine) this.fetchChannel()
  },
  methods: {
    leaveChannel() {
      if (!confirm(`${this.channel.display_name} verlassen?`)) return
      let me = this
      this.$chat.delete(`channels/${this.channelId}/members/`).then(() => {
        me.$router.back()
      })
    },
    fetchChannel() {
      let me = this
      this.$chat.get('channels/').then(response => {
        let channels = response.data.results || response.data
        me.channel = channels.filter(channel => channel.name == me.channelName)[0]
        if (me.channel)
          me.channelId = me.channel.id
      })
    }
  }
}
</script>
